module.exports = __webpack_public_path__ + "img/ring_g_s_null_null@2x.89df1d79.png";